import iconPathCalendarRecurring from 'raw-loader!@/assets/icon-path-calendar-recurring.txt';
import iconPathCardGroup from 'raw-loader!@/assets/icon-path-card-group.txt';
import iconPathCardPersonal from 'raw-loader!@/assets/icon-path-card-personal.txt';
import iconPathCardInvitation from 'raw-loader!@/assets/icon-path-card-invitation.txt';
import { mdiVideo, mdiCards, mdiVideoVintage, mdiWalletGiftcard, mdiCurrencyUsd, mdiDomain, mdiAccountGroup, mdiEmailMultiple, mdiBullhorn, mdiApplicationOutline, mdiXml, mdiPalette, mdiEmailFast, mdiEmailOpenMultiple, mdiGift, mdiChevronRight, mdiHandshakeOutline, mdiBriefcase, mdiEmailOpen, mdiEmail, mdiChevronLeft, mdiPause, mdiPlay, mdiFrequentlyAskedQuestions, mdiTrophy, mdiFormatFloatLeft, mdiPencilRuler } from '@mdi/js';


function getRouteName(sectionName) {
  return 'start-' + sectionName.replace(/[ \/]+/g, '-').toLowerCase();
}


const SECTIONS = [
  {
    name: 'Group cards',
    subtitle: 'The best way to create and send personalized, memorable, group greeting cards',
    icon: iconPathCardGroup,
    // media: { id: 'b1a94da6-08ef-4a9e-85a0-4d0642348508', alt: 'Group cards', video: true },
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/bfdba8e0-fbde-42a7-b58b-c849d27733f0_480x672.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/f040f399-aa1c-45e3-98af-9e6cc8418614_480x672.webp",
        "mp4": "https://cdn.ellacard.com/r/f040f399-aa1c-45e3-98af-9e6cc8418614_480x672.mp4"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/e4be1177-6d26-41be-a3c5-8f4b0086acc3_480x672.jpg"
      }
    ],
    bg: {
      src: 'https://cdn.ellacard.com/page_backgrounds/Light Bokeh.mp4',
      color: '#d1ad7a'
    },
    actionName: 'Start a group card',
    actionTo: { name: 'catalog-category', params: { category: 'group-cards' }, hash: '#search' }
  },
  {
    name: 'Invitations',
    subtitle: 'Create and send beautiful custom invitations and collect RSVPs',
    icon: iconPathCardInvitation,
    // media: { id: '692658bb-99df-4546-abed-5deee95277e3', alt: 'Invitations', video: true },
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/430466f4-9110-4f21-8b08-4a5bd37d65a3_480x672.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/d8bcf4ec-f2b1-47ed-a6c5-68bbba5a2b21_480x672.webp",
        "mp4": "https://cdn.ellacard.com/r/d8bcf4ec-f2b1-47ed-a6c5-68bbba5a2b21_480x672.mp4"
      }
    ],
    bg: {
      src: 'https://cdn.ellacard.com/media/79a3cfe8-f198-4fc9-b619-36bb35384f66/lg.mp4',
      color: '#EF9C7E'
    },
    actionName: 'Start an invitation',
    actionTo: { name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }
  },
  {
    name: 'Gift cards',
    subtitle: 'Send gift cards from thousands of international merchants',
    icon: mdiWalletGiftcard,
    media: { id: '24acb33c-73b9-4115-afdb-8855cce1c126', alt: 'Gift cards', video: true },
    // bg: { src: 'https://cdn.ellacard.com/page_backgrounds/Pink Hearts.mp4', color: '#fde8e4' }
    // bg: { src: 'https://cdn.ellacard.com/media/4c0dfb87-b896-4a6d-bd82-15f4e13069bd/lg.mp4', color: '#CDCECC'  }
    bg: { src: 'https://cdn.ellacard.com/media/61ce9982-fda2-4358-a0e6-0c55e55cf523/lg.webp', color: '#97a8bd'  },
    actionName: 'Send a gift card',
    actionTo: { name: 'catalog-gift-cards', hash: '#search' }
  },
  {
    name: 'Holidays',
    subtitle: "Make your family's annual holiday card unforgettable with custom pictures and videos on unlimited pages",
    icon: mdiGift,
    // media: { id: 'e0b050cc-8095-464d-a309-d9da2e8fcdd8', alt: 'Holiday card example', video: true },
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/77fd2296-eabb-405e-a323-f077feb2af9b_480x672.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/33357177-b9cc-42ec-8213-9946e3e8930f_480x672.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/2e8a98f0-c72f-448e-8b66-26fe6bdc39f9_480x672.jpg"
      }
    ],
    bg: {
      src: 'https://cdn.ellacard.com/page_backgrounds/Festive Holiday Baking.jpg',
      color: '#926E4A'
    },
    actionName: 'Start a holiday card',
    actionTo: { name: 'catalog-category', params: { category: 'holiday-cards' }, hash: '#search' }
  },
  {
    name: 'Video maker',
    subtitle: "Make an instant group video for any occasion – pick a theme, add photos and videos, invite friends / family to add, and it all works instantly in your browser",
    icon: mdiVideoVintage,
    media: { id: 'e4ccfbb2-ae92-4e43-8238-47252dca0856', alt: 'Video maker example', video: true },
    bg: {
      src: 'https://cdn.ellacard.com/page_backgrounds/Comic Book.mp4',
      color: '#944c49'
    },
    actionName: 'Start a video',
    actionTo: { name: 'catalog-video' }
  },
  // {
  //   name: 'Business',
  //   icon: mdiDomain,
  //   media: { id: '', alt: '', color: '' },
  //   bg: {
  //     src: 'https://cdn.ellacard.com/page_backgrounds/Corner Potted Succulent.jpg',
  //     color: '#EEEAE7'
  //   }
  // },
  {
    name: 'Recognition',
    nameLong: 'Employee recognition',
    subtitle: 'Group-signed cards and gift cards at scale with our suite of business tools',
    icon: mdiHandshakeOutline,
    // media: { id: '6b952415-3d73-459d-bf6a-f25a0476aee0', alt: 'Work anniversary example card', video: true },
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/65732f65-67a5-4a13-a26a-d418dc315a5f_480x672.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/dfd52e4a-95c2-481b-bc9d-b8ada4a2fbf5_480x672.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/91dc463d-e748-4a33-ad2a-9a4f8a1df9a0_480x672.webp",
        "mp4": "https://cdn.ellacard.com/r/91dc463d-e748-4a33-ad2a-9a4f8a1df9a0_480x672.mp4"
      }
    ],
    bg: {
      src: 'https://cdn.ellacard.com/media/b4da18a0-2d77-4246-86ad-c5931c71e2cd/lg.webp',
      color: '#5a7563'
    },
    actionName: 'Set up an organization',
    actionTo: { name: 'account-org' }
  },
  {
    name: 'Automation',
    subtitle: 'Automation tools for sending group e-cards',
    icon: iconPathCalendarRecurring,
    media: { id: '4c484036-9f33-4725-b6c1-0509f97a02ef', alt: 'Automation', video: true },
    bg: { src: 'https://cdn.ellacard.com/media/d2502de8-328d-4b8b-acef-194ffa307392/lg.webp', color: '#62483A' },
    actionName: 'Create an automation',
    actionTo: { name: 'automation' }
  },
  {
    name: 'Bulk email',
    subtitle: 'A better way to send email newsletters, updates, and holiday card campaigns',
    icon: mdiEmailMultiple,
    media: { id: '02210a19-7da6-4f8c-a46c-0650be6f628c', alt: 'Screenshot of bulk email template builder' },
    bg: { src: 'https://cdn.ellacard.com/media/b9bc3198-2ae3-4e70-8f41-4b45c8fdfe09/lg.mp4', color: '#97836E' },
    actionName: 'Create an email campaign',
    actionTo: { name: 'bulk-email' }
  },
  // {
  //   name: 'Branding',
  //   hash: '#branding',
  //   icon: mdiPalette,
  //   media: { id: '74458356-0685-440d-8a14-bb7cd66aa31e', alt: 'Custom branding examples', video: true },
  //   bg: {
  //     src: 'https://cdn.ellacard.com/page_backgrounds/Sparkling White.mp4',
  //     color: '#c1c0c4'
  //   }
  // },
  {
    name: 'Embedding API',
    subtitle: "Let your site visitors use Ellacard's editing tools to send and open e-cards directly on your site",
    icon: mdiXml,
    media: { id: 'ed170d7d-705b-4ccb-9ad4-f54371580fbe', alt: 'Embedding example on florist website', video: true },
    bg: { src: 'https://cdn.ellacard.com/page_backgrounds/Yellow Canvas.jpg', color: '#EFAD01' },
    actionName: 'Create your widget',
    actionTo: { name: 'account-org-embedding' }
  },
  // {
  //   name: 'Ellacard API',
  //   icon: mdiXml,
  //   media: { id: '', color: '' },
  //   bg: {
  //     src: 'https://cdn.ellacard.com/page_backgrounds/Intricate Ferns on Black.jpg',
  //     color: '#2F4835'
  //   }
  // }
];


export { SECTIONS, getRouteName };
